import React, { useState } from "react";
import { Form, Button, ProgressBar } from "react-bootstrap";
import Stepper from "react-stepper-horizontal";
import ProductInfoForm from "./product-info-form";
import ProductPrice from "./productPrices";
import { useNavigate } from "react-router-dom";
import SelecatableStores from "../Store/SelectableStores";

const MultiStepForm = () => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [productId, setProductId] = useState(0);
  const [priceId, setPriceId] = useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handlePrevious = () => {
    setActiveStep(activeStep - 1);
  };

  return (
    <div className="container-fluid">
      <div>
        <Stepper
          steps={[
            { title: "Product Information" },
            { title: "Price" },
            { title: "Assign Branches" },
          ]}
          activeStep={activeStep}
          activeColor={"#5096FF"}
          titleFontSize={18}
          size={38}
          defaultColor="#eee"
          activeTitleColor="#000"
          completeTitleColor="#5096FF"
          defaultTitleColor="#000"
          circleFontColor="#000"
          completeBarColor="#5096FF"
          lineMarginOffset={0}
        />
      </div>

      {activeStep === 0 && (
        <ProductInfoForm
          onSubmitClick={(id) => {
            setProductId(id);
            handleNext();
          }}
        />
      )}
      {activeStep === 1 && (
        <ProductPrice
          id={productId}
          onSubmitClick={() => {
            handleNext();
          }}
        />
      )}
      {activeStep === 2 && (
        <SelecatableStores
          type={"product"}
          id={productId}
          onSubmitClick={() => {
            navigate(-1);
          }}
        />
      )}
    </div>
  );
};

export default MultiStepForm;
